<template>
  <div style="margin: 30px">
    <v-row align="center" style="margin: 0 20px 0 0">
      <v-col class="d-flex" cols="12" sm="6" md="6">
        <div>
          <font-awesome-icon
            icon="angle-right"
            class="navIcon"
            size="2x"
            @click="addWeek(-1)"
          />
          <span class="dateRange">{{ currentWeekString }}</span>

          <font-awesome-icon
            icon="angle-left"
            class="navIcon"
            size="2x"
            @click="addWeek(1)"
          />
        </div>
      </v-col>
      <!-- <v-col class="d-flex" cols="6" sm="6" md="3" style="direction: ltr;">
        
      </v-col> -->
      <v-col cols="12" sm="6" md="6">
        <app-history
          title="کپی کردن منو"
          style="float: left"
          @clicked="
            showCopyDialog = true;
            currentCopy = JSON.parse(JSON.stringify(initCopy));
          "
        />
        <v-btn
          v-if="showDeleteButton"
          color="red white--text"
          rounded
          style="margin-top: 20px;float: left;"
          @click="removeDays()"
        >
          حذف منو
        </v-btn>
        <!-- <app-history
          title="حذف منو"
          style="float: left"
          @clicked="
            showCopyDialog = true;
            currentCopy = JSON.parse(JSON.stringify(initCopy));
          "

        /> -->
      </v-col>
    </v-row>

    <div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-right" style="width: 20%">تاریخ</th>

              <th
                v-for="item in meals"
                :key="item.id"
                class="text-center"
                style="width: 25%"
              >
                {{ item.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in 7" :key="item">
              <td>
                <v-simple-checkbox
                  v-model="selectedDays[item - 1]"
                  :ripple="false"
                ></v-simple-checkbox>
                {{ dateGenerator(item - 1) }}
              </td>
              <td v-for="meal in meals" :key="meal.id" class="text-center">
                <div
                  class="menuBorder"
                  :style="[
                    getItems(meal, item - 1) == '---'
                      ? { 'background-color': 'lightgray' }
                      : {},
                  ]"
                >
                  <div class="menuHolder">
                    <div class="top-side">
                      {{ getItems(meal, item - 1) }}
                    </div>
                  </div>
                  <div class="bottom-side">
                    <v-btn
                      @click="editItem(meal, item - 1)"
                      class="menuDetail"
                      color="primary white--text"
                    >
                      بیشتر
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-dialog persistent v-model="showMenuDialog" content-class="foodsDialog">
      <app-history title="افزودن غذا" @clicked="addToMenu" />
      <v-data-table
        :headers="menuHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :items="selectedMenu"
        :header-props="$store.getters.headerProps"
        item-key="sort"
      >
        <template v-slot:[`item.foodCapacity`]="{ item }">
          <v-text-field
            outlined
            dense
            v-model="item.foodCapacity"
            class="menuInput"
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:[`item.price`]="{ item, index }">
          <v-text-field
            outlined
            dense
            v-model="item.price"
            class="menuInput"
            hide-details
            @change="updateItemPrices($event, index)"
          ></v-text-field>
        </template>
        <template v-slot:[`item.foodId`]="{ item }">
          <v-autocomplete
            v-model="item.foodId"
            outlined
            dense
            :items="foods"
            item-text="name"
            item-value="id"
            class="menuInput"
            no-data-text="داده ای برای نمایش وجود ندارد."
            :filter="customFilter"
            hide-details
          ></v-autocomplete>
        </template>
        <template v-slot:[`item.moves`]="{ index }">
          <span style="display: flex">
            <v-btn
              icon
              @click="moveUp(index)"
              :class="[index <= 0 ? 'hideIcon' : '']"
            >
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="moveDown(index)"
              :class="[index >= selectedMenu.length - 1 ? 'hideIcon' : '']"
            >
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </span>
        </template>

        <template v-slot:[`item.actions`]="{ index }">
          <span style="display: flex">
            <span class="menuActions" @click="editMenuPrice(index)">
              <font-awesome-icon icon="money-bill" />
            </span>
            <span class="menuActions" @click="removeItem(index)">
              <font-awesome-icon icon="times" />
            </span>
          </span>
        </template>
      </v-data-table>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showMenuDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showPriceDialog" content-class="foodsDialog">
      <v-data-table
        :headers="menuPriceHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :items="
          selectedMenu[selectedIndex] != undefined
            ? selectedMenu[selectedIndex].menuPrices
            : initMenu.menuPrices
        "
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.jarimehAdameTahvil`]="{ item }">
          <v-text-field
            outlined
            dense
            v-model="item.jarimehAdameTahvil"
            class="menuInput"
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:[`item.kprice`]="{ item }">
          {{ GetKprice(item.kprice) }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          <v-text-field
            outlined
            dense
            v-model="item.price"
            class="menuInput"
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:[`item.tedadMojazSefaresh`]="{ item }">
          <v-text-field
            outlined
            dense
            v-model="item.tedadMojazSefaresh"
            class="menuInput"
            hide-details
          ></v-text-field>
        </template>
      </v-data-table>
      <v-row class="ltr">
        <v-btn class="dialogButton" rounded @click="showPriceDialog = false">
          بستن
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showCopyDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>کپی از</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5">
          <v-text-field
            :value="currentCopy.startDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5">
          <v-text-field
            :value="currentCopy.endDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>کپی به</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5">
          <v-text-field
            :value="currentCopy.destinationDate"
            @click="onClickDate(3)"
            readonly
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="5">
          <v-text-field
            :value="endDestinationDate"
            readonly
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="copyMenus"
          :disabled="apiRunning"
        >
          کپی
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showCopyDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
    <date-picker
      ref="datepicker1"
      v-model="currentCopy.startDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      :disable="[
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
      ]"
      @change="onChangeDate($event, 'startDate')"
    ></date-picker>
    <date-picker
      ref="datepicker2"
      v-model="currentCopy.endDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      :disable="[
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
      ]"
      @change="onChangeDate($event, 'endDate')"
    ></date-picker>
    <date-picker
      ref="datepicker3"
      v-model="currentCopy.destinationDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput3"
      :disable="[
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
      ]"
      @change="onChangeDate($event, 'destinationDate')"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <input id="fileInput2" ref="fileInput2" />
    <input id="fileInput3" ref="fileInput3" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import {
  GetBranchMenus,
  SaveMenu,
  DeleteMenu,
  DeleteDays,
  CopyMenu,
} from "@/api/menus";
import { GetBranchActiveMeals } from "@/api/meals";
import { GetBranchFoods } from "@/api/foods";
import moment from "moment-jalaali";
import { toArabicCharacter } from "@/utils/constants";
import PlusMinusField from "@/components/PlusMinusField";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
    appMinusplusfield: PlusMinusField,
  },
  data() {
    return {
      showMenuDialog: false,
      showPriceDialog: false,
      showCopyDialog: false,
      menus: [],
      meals: [],
      foods: [],
      selectedMenu: [],
      selectedMealId: 0,
      selectedTarikh: "",
      initMenu: {
        foodId: 0,
        mealId: 0,
        tarikh: "",
        foodCapacity: 0,
        sort: 0,
        id: "0",
        menuPrices: [],
      },
      selectedDays: new Array(7).fill(false),
      currentCopy: {},
      initCopy: {
        startDate: "",
        endDate: "",
        destinationDate: "",
      },
      selectedIndex: -1,
      maxSort: 0,
      menuDate: moment().startOf("week"),
      menuHeaders: [
        { text: "", value: "moves", width: "10%" },

        // {
        //   text: "ترتیب",
        //   value: "sort",
        //   width: "10%",
        // },
        {
          text: "نام",
          value: "foodId",
          width: "35%",
        },

        {
          text: "ظرفیت",
          value: "foodCapacity",
          width: "15%",
        },
        {
          text: "قیمت(ریال)",
          value: "price",
          width: "22%",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "20%",
        },
      ],
      menuPriceHeaders: [
        {
          text: "تعرفه",
          value: "kprice",
          width: "10%",
        },

        {
          text: "قیمت(ریال)",
          value: "price",
          width: "20%",
        },
        {
          text: "تعداد مجاز سفارش",
          value: "tedadMojazSefaresh",
          width: "20%",
        },
        {
          text: "جریمه عدم تحویل(ریال)",
          value: "jarimehAdameTahvil",
          width: "20%",
        },
      ],
      isEdit: false,
    };
  },

  created() {
    for (let i = 1; i <= 5; i++) {
      this.initMenu.menuPrices.push({
        kprice: i,
        price: 0,
        jarimehAdameTahvil: 0,
        tedadMojazSefaresh: 1,
      });
    }
    //this.selectedMenu.push(this.initMenu);
    if (this.currentBranch) {
      this.GetBranchActiveMeals();
      this.GetBranchFoods();
      this.GetBranchMenus();
    }
  },
  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    currentWeekString() {
      return (
        this.menuDate.format("dddd jYYYY/jMM/jDD") +
        " تا " +
        this.endOfWeek.format("dddd jYYYY/jMM/jDD")
      );
    },

    endOfWeek() {
      return moment(this.menuDate).endOf("week");
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    showDeleteButton() {
      return this.selectedDays.indexOf(true) >= 0;
    },
    endDestinationDate() {
      if (
        this.currentCopy.startDate < this.currentCopy.endDate &&
        this.currentCopy.endDate < this.currentCopy.destinationDate
      ) {
        const diff = this.convertToDate(this.currentCopy.endDate).diff(
          this.convertToDate(this.currentCopy.startDate),
          "days"
        );
        return this.convertToDate(this.currentCopy.destinationDate)
          .add(diff, "days")
          .format("jYYYY/jMM/jDD");
      }
      return "";
    },
  },

  methods: {
    convertToDate(dateInput) {
      return dateInput ? moment(dateInput, "jYYYY/jMM/jDD") : null;
    },
    moveUp(index) {
      if (index > 0) {
        let temp = this.selectedMenu.slice();

        [temp[index - 1], temp[index]] = [
          this.selectedMenu[index],
          this.selectedMenu[index - 1],
        ];
        this.selectedMenu = temp.slice();
      }
    },
    // Move items down in the array
    moveDown(index) {
      if (index < this.selectedMenu.length - 1) {
        let temp = this.selectedMenu.slice();

        [temp[index], temp[index + 1]] = [
          this.selectedMenu[index + 1],
          this.selectedMenu[index],
        ];
        this.selectedMenu = temp.slice();
      }
    },
    addWeek(index) {
      this.menuDate = moment(this.menuDate).add(index, "weeks");
      this.GetBranchMenus();
    },
    customFilter(item, queryText, itemText) {
      const text = toArabicCharacter(item.name);

      const searchText = toArabicCharacter(queryText);

      return text.indexOf(searchText) > -1;
    },
    updateItemPrices(event, index) {
      const item = JSON.parse(JSON.stringify(this.selectedMenu))[index];
      for (let menuPrice of item.menuPrices) {
        menuPrice.price = event;
      }

      this.selectedMenu[index] = item;
    },
    GetKprice(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
          case 4:
          return "آزاد";
        default:
          return "سایر";
      }
    },
    GetBranchActiveMeals() {
      return new Promise((resolve, reject) => {
        GetBranchActiveMeals(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.meals = response.data.items;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetBranchFoods() {
      return new Promise((resolve, reject) => {
        GetBranchFoods(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.foods = response.data.items;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    dateGenerator(offset) {
      return moment(this.menuDate)
        .add(offset, "days")
        .format("dddd jDD jMMMM");
    },
    addToMenu() {
      const newMenu = Object.assign({}, this.initMenu);
      newMenu.sort = ++this.maxSort;
      newMenu.mealId = this.selectedMealId;

      this.selectedMenu.push(newMenu);
    },
    GetBranchMenus() {
      this.$store.commit("SET_TABLE_TEXT", true);
      this.$store.commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        GetBranchMenus(
          this.currentBranch.id,
          this.menuDate.format("jYYYY/jMM/jDD"),
          this.endOfWeek.format("jYYYY/jMM/jDD")
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.menus = response.data.items;
            this.$store.commit("SET_PROGRESS_SHOW", false);
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    editItem(meal, offset) {
      this.selectedMenu = [];
      this.selectedMealId = meal.id;
      this.selectedTarikh = moment(this.menuDate)
        .add(offset, "days")
        .format("jYYYY/jMM/jDD");
      this.maxSort = 0;
      for (const menu of this.menus) {
        if (
          menu.mealId == this.selectedMealId &&
          menu.tarikh == this.selectedTarikh
        ) {
          if (menu.menuPrices.length > 0) {
            let samePrice = menu.menuPrices[0].price;
            for (const menuPrice of menu.menuPrices) {
              if (samePrice != menuPrice.price) {
                samePrice = "";
                break;
              }
            }
            menu.price = samePrice;
          }
          this.selectedMenu.push(menu);
          this.maxSort = Math.max(this.maxSort, menu.sort);
        }
      }
      if (this.selectedMenu.length == 0) {
        this.addToMenu();
      }

      this.showMenuDialog = true;
      this.isEdit = true;
    },

    getItems(meal, offset) {
      let foods = [];
      const mealId = meal.id;
      const tarikh = moment(this.menuDate)
        .add(offset, "days")
        .format("jYYYY/jMM/jDD");
      for (const menu of this.menus) {
        if (menu.mealId == mealId && menu.tarikh == tarikh) {
          foods.push(menu.food.name);
        }
      }

      return foods.length == 0 ? "---" : foods.join("، ");
    },

    editMenuPrice(index) {
      this.selectedIndex = index;

      this.showPriceDialog = true;
    },
    removeItem(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این غذا از منو هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index == -2) {
        const days = [];

        for (let i = 0; i < 7; i++) {
          if (this.selectedDays[i]) {
            days.push(
              moment(this.menuDate)
                .add(i, "days")
                .format("jYYYY/jMM/jDD")
            );
          }
        }
        DeleteDays(days, this.currentBranch.id)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetBranchMenus();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      } else if (index != -1) {
        const id = this.selectedMenu[index].id;
        if (id > 0) {
          DeleteMenu(id)
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.message);

              if (data.success) {
                this.GetBranchMenus();
                this.selectedMenu.splice(index, 1);
              }
            })

            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        } else {
          this.selectedMenu.splice(index, 1);
        }
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    removeDays() {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", -2);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این روزها از منو هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";
      for (let element of this.selectedMenu) {
        if (element.foodId == 0) {
          text = "همه غذاها بایستی انتخاب شوند.";
          break;
        }
      }

      if (text == "") {
        const ids = this.selectedMenu.map((item) => item.foodId);

        if (new Set(ids).size !== ids.length)
          text = "غذای تکراری نبایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else if (this.selectedMenu.length > 0) {
        this.$store.commit("SET_API_RUNNING", true);
        let sortCounter = 0;
        for (let element of this.selectedMenu) {
          SaveMenu(
            element.id,
            this.currentBranch.id,
            element.foodId,
            element.mealId,
            this.selectedTarikh,
            ++sortCounter,
            element.foodCapacity,
            element.menuPrices
          )
            .then((response) => {
              const data = response.data;
              //this.$store.commit("SET_SNACKBAR_TEXT", data.message);

              this.showMenuDialog = false;
              this.GetBranchMenus();
            })
            .catch((error) => {
              this.$store.commit("SET_API_RUNNING", false);
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
        }
        this.$store.commit("SET_API_RUNNING", false);
      } else {
        this.showMenuDialog = false;
        this.GetBranchMenus();
      }
    },

    onClickDate(index) {
      this.$refs[`fileInput${index}`].click();
    },
    onChangeDate($event, datetype) {
      this.currentCopy[datetype] = moment($event).format("jYYYY/jMM/jDD");
    },
    copyMenus() {
      if (
        !this.currentCopy.startDate ||
        !this.currentCopy.endDate ||
        !this.currentCopy.destinationDate
      ) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "همه تاریخ ها بایستی انتخاب شوند."
        );
        return;
      }
      if (this.currentCopy.startDate > this.currentCopy.endDate) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "تاریخ پایان بایستی از  تاریخ شروع بزرگتر باشد."
        );
        return;
      }
      if (this.currentCopy.endDate > this.currentCopy.destinationDate) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "تاریخ مقصد بایستی از تاریخ تاریخ مبدا بزرگتر باشد."
        );
        return;
      }
      this.$store.commit("SET_API_RUNNING", true);

      CopyMenu(
        this.currentBranch.id,
        this.currentCopy.startDate,
        this.currentCopy.endDate,
        this.currentCopy.destinationDate
      )
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.message);
          this.showCopyDialog = false;
          this.$store.commit("SET_API_RUNNING", false);
          this.GetBranchMenus();
        })
        .catch((error) => {
          this.$store.commit("SET_API_RUNNING", false);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style scoped>
.navIcon {
  position: relative;
  top: 5px;
  cursor: pointer;
}
.dateRange {
  width: 250px;
  display: inline-block;
  text-align: center;
}
.v-data-table th {
  color: black !important;
}
.v-simple-checkbox {
  float: right;
  margin-left: 5px;
}
</style>
<style>
.foodsDialog {
  max-width: 960px;
  padding: 10px 20px 30px;
  margin: 0 30px;
  background-color: white;
}
.menuInput {
  width: 100%;
  margin: 10px 0 !important;
}
.hideIcon {
  visibility: hidden;
}

.menuActions {
  font-size: 1.3em;
  margin: 5px;
  width: 40px !important;
  border: 1px black solid;
  height: 40px !important;
  border-radius: 20px;
  display: inline-block;
  text-align: center;
  padding-top: 7px;
  cursor: pointer;
}

.menuBorder {
  border: 2px solid #707742;
  padding: 10px;
  border-radius: 20px;
  margin: 10px 0;
}

.menuHolder {
  text-align: right;
  display: block;
  overflow: auto;
  padding: 10px 0;
}
.menuItem {
  margin-bottom: 10px;
}
.menuDetail {
  min-width: 40px !important;
  height: 28px !important;
  padding: 0 10px !important;
  border-radius: 14px;
}

.right-side {
  float: right;
  width: 50%;
}
.left-side {
  width: 50%;
  float: right;
  text-align: left;
}

.menuBorder .right-side {
  width: calc(100% - 150px);
}

.menuBorder .left-side {
  width: 140px;
}

.top-side {
  display: block;
  overflow: hidden;
}

.startMenu {
  padding: 15px 5px;
}

.bottom-side {
  display: block;
  overflow: hidden;
  text-align: left;
}
</style>
